import { render, staticRenderFns } from "./ExamView.vue?vue&type=template&id=8aee8c74&scoped=true"
import script from "./ExamView.vue?vue&type=script&lang=js"
export * from "./ExamView.vue?vue&type=script&lang=js"
import style0 from "./ExamView.vue?vue&type=style&index=0&id=8aee8c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aee8c74",
  null
  
)

export default component.exports